import { render, staticRenderFns } from "./ZendeskTextEditor.vue?vue&type=template&id=fc88d376&"
import script from "./ZendeskTextEditor.vue?vue&type=script&lang=js&"
export * from "./ZendeskTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports